<div class="bg-light d-flex flex-column justify-content-between">
  <nav class="navbar navbar-expand navbar-light flex-column shadow-sm sticky-md-top bg-white mb-4">
    <div class="col-12 border-bottom pb-2">
      <div class="container-fluid-boxed d-flex justify-content-between ">
        <button type="button" class="btn btn-outline-light fw-bold btn-light-no-border text-body-tertiary" (click)="goBack()">
          <span class="bi-arrow-left"></span>&nbsp;Back
        </button>
        <div class="col text-end">
          <app-company-watchlist-btn [watchlist]="watchlist" (watchlistToggle)="toggleToWatchlist($event, company)"></app-company-watchlist-btn>
          <app-company-portfolio-btn [portfolio]="portfolio" (portfolioToggle)="toggleToPortfolio($event, company)"></app-company-portfolio-btn>
          <button class="btn rounded-0" type="button" (click)="openHelpPage()" [matTooltip]="'Methodology Documents'" matTooltipPosition="below">
            <i class="bi bi-question-circle-fill fs-4 text-body-tertiary"></i>
          </button>
        </div>
      </div>
    </div>
    <button
      class="navbar-toggler"
      type="button"
      data-mdb-toggle="collapse"
      data-mdb-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <i class="fas fa-bars"></i>
    </button>
    <div class="row container-fluid-boxed pt-2" id="navbarNav">
      <app-company-info-summary [company]="company"></app-company-info-summary>
    </div>
    <div class="row container-fluid-boxed">
      <div class="col-12 me-2">
        <p class="small mb-0 text-end text-body-tertiary">Most recent data as of: {{company.updated_at | date}}</p>
      </div>
    </div>
  </nav>
  <div class="container-fluid-boxed">
    <div class="row mb-4">
      <div class="col-sm-9 order-sm-4 order-first">
        <div class="card border-0 mb-4">
          <div class="card-body">
            <app-company-map-chart [company]="company"></app-company-map-chart>
          </div>
        </div>
        <div class="card border-0">
          <div class="card-body">
            <h3 class="card-title pt-2">Current Company Directors</h3>
            <app-director-stat-list [directorships]="filterCurrent(company.directorships)" [company]="company" *ngIf="company.directorships"></app-director-stat-list>
          </div>
        </div>
      </div>
      <div class="col-sm-3 order-sm-4">
        <app-featured-list-week [articles]="news" *ngIf="news"></app-featured-list-week>
      </div>
    </div>
  </div>
</div>
